module.exports = require("is");